import { EuiButtonIcon, EuiToolTip } from "@elastic/eui";
import React from "react";
import { dateToFullDateAndTime } from "../../../utils/dateAndTime";

function Creator({ content }) {
    return (
        <div style={{ marginInline: "20px" }}>
            <EuiToolTip
                position="left"
                title="Profile creation info"
                content={
                    <div>
                        <p>
                            {content?.name || content?.firstName + content?.lastName} -
                            {content?.userRoles}
                        </p>
                        <p>{content?.email}</p>
                        <p> {dateToFullDateAndTime(content?.createdAt)}</p>
                    </div>
                }
                repositionOnScroll
            >
                <EuiButtonIcon
                    iconType="questionInCircle"
                    aria-label="info"
                    iconSize="l"
                />
            </EuiToolTip>
        </div>
    );
}

export default Creator;
